import { render, staticRenderFns } from "./DataIteratItemContent.vue?vue&type=template&id=920992dc"
import script from "./DataIteratItemContent.vue?vue&type=script&lang=js"
export * from "./DataIteratItemContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports